import React, { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../utils/authUtils';

const ApplicationStatusBanner = ({ companiesCount, onDismiss }) => {
  const [isDismissing, setIsDismissing] = useState(false);

  const handleDismiss = async () => {
    setIsDismissing(true);
    try {
      const authToken = localStorage.getItem('studentAuthToken');

      await axios.post(
        `${API_URL}/api/student/dismiss-status-reminder`,
        {},
        { headers: { 'Authorization': `Bearer ${authToken}` } }
      );

      // Call parent's onDismiss callback to hide the banner
      if (onDismiss) {
        onDismiss();
      }
    } catch (error) {
      console.error('Error dismissing reminder:', error);
      alert('Failed to dismiss reminder. Please try again.');
    } finally {
      setIsDismissing(false);
    }
  };

  const handleScrollToMatches = () => {
    // Scroll to the "Companies You're Interested In" section
    const element = document.querySelector('[class*="Companies You\'re Interested In"]')?.parentElement;
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      // Fallback: try to scroll by section order
      window.scrollTo({ top: 800, behavior: 'smooth' });
    }
  };

  return (
    <div className="bg-green-50 border-l-4 border-green-500 p-4 mb-6 rounded-r-lg shadow-sm">
      <div className="flex items-center justify-between">
        <div className="flex items-center flex-1">
          <div className="flex-shrink-0">
            <span className="text-2xl">📋</span>
          </div>
          <div className="ml-3 flex-1">
            <p className="text-sm font-medium text-green-800">
              Update your application status for{' '}
              <button
                onClick={handleScrollToMatches}
                className="font-bold underline hover:text-green-900 transition-colors"
              >
                {companiesCount} {companiesCount === 1 ? 'company' : 'companies'}
              </button>
            </p>
            <p className="text-xs text-green-600 mt-1">
              Help us track your progress by updating the status of your applications
            </p>
          </div>
        </div>
        <div className="ml-4 flex-shrink-0">
          <button
            onClick={handleDismiss}
            disabled={isDismissing}
            className="inline-flex items-center px-3 py-1.5 border border-green-300 text-sm font-medium rounded-md text-green-700 bg-white hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors disabled:opacity-50 disabled:cursor-wait"
          >
            {isDismissing ? 'Dismissing...' : 'Dismiss'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApplicationStatusBanner;
